import { toastr } from 'react-redux-toastr';
import { BASE_PRINT_AGENT_URL } from '../../config/endpoints';
import {
  addImage,
  addQrCode,
  addText,
  createPdfDocument,
  setFont,
} from '../pdf';
import LogoCiva from '../../resources/images/logo-civa.png';
import { tzNormalizeDate } from '../date';
import { TIME_FORMAT } from '../../config/locale';

const margin = 3;
const qrWidth = 34;
const qrHeight = 34;
const imageWidth = 25;
const imageHeight = 8;
let myY = -margin;

const printBaggageItemSticker = async (
  doc,
  {
    sourceLocationName,
    destinationLocationName,
    passengerName,
    itemCorrelation,
    itemNumber,
    itemTotal,
    weight,
    price,
    qrData,
    isFirstPrint,
    ticketCount,
    tagNumber,
    isSpecial,
    itemCategoryName,
    departureDate,
  },
) => {
  myY = -margin;

  if (!isFirstPrint) {
    doc.addPage('l', 'mm');
  }

  const column1X = 3;
  const column2X = 70;

  addImage(doc, LogoCiva, column1X, myY + margin * 2, imageWidth, imageHeight);

  setFont(doc, 'bold');
  doc.setFontSize(16);

  const title = isSpecial ? 'EQUIPAJE ESPECIAL' : 'EQUIPAJE';

  if (isSpecial) {
    addText(
      doc,
      title,
      column1X + imageWidth + 3,
      myY + margin * 4,
      80,
      'left',
    );
  } else {
    addText(doc, title, column1X + 47, myY + margin * 4, 100, 'center');
  }

  myY += margin * 2;

  setFont(doc, 'bold');
  doc.setFontSize(13);

  const pageWidth = doc.internal.pageSize.getWidth();
  const correlationX = 52;
  const correlativoWrapped = doc.splitTextToSize(
    itemCorrelation,
    pageWidth - correlationX - margin,
  );
  doc.text(correlativoWrapped, correlationX, 15, { align: 'left' });

  myY += margin * 2;

  setFont(doc, 'bold');
  doc.setFontSize(8);
  addText(doc, 'PASAJERO:', column1X, (myY += margin * 1.8), 75, 'left');
  setFont(doc);
  doc.setFontSize(10);

  const passengerNameWidth = 45;
  const passengerText = `${passengerName} (${ticketCount})`;
  const passengerWrapped = doc.splitTextToSize(
    passengerText,
    passengerNameWidth,
  );
  myY += margin;
  addText(doc, passengerText, column1X, myY, passengerNameWidth, 'left');

  const passengerLineHeight = 3.1;
  myY += (passengerWrapped.length - 1) * passengerLineHeight;

  myY += margin * 0.4;

  setFont(doc, 'bold');
  doc.setFontSize(8);
  addText(
    doc,
    'Número de Ticket:',
    column1X,
    (myY += margin * 1.5),
    75,
    'left',
  );
  setFont(doc);
  doc.setFontSize(13);
  addText(doc, tagNumber, column1X, (myY += margin * 1.2), 75, 'left');

  // myY += margin * 0.5;

  setFont(doc, 'bold');
  doc.setFontSize(8);
  doc.text('EMBARQUE:', column1X, (myY += margin * 1.2));

  setFont(doc, 'bold');
  doc.setFontSize(10);
  const originText = `${sourceLocationName.toUpperCase()} (${departureDate})`;
  const originWrapped = doc.splitTextToSize(originText, 70);
  doc.text(originWrapped, column1X, (myY += margin * 1.2), { align: 'left' });
  myY += originWrapped.length;

  setFont(doc, 'bold');
  doc.setFontSize(8);
  doc.text('DESEMBARQUE:', column1X, (myY += margin * 1.2));
  doc.setFontSize(18);
  const destinyText = destinationLocationName.toUpperCase();
  const destinyWrapped = doc.splitTextToSize(destinyText, 70);

  doc.text(destinyWrapped, column1X, (myY += margin * 1.9), { align: 'left' });

  const myYAfterDestination =
    destinyWrapped.length >= 2 ? (margin + 2) * destinyWrapped.length : margin;

  myY += myYAfterDestination;

  setFont(doc, 'bold');
  doc.setFontSize(13);
  const MAX_LENGTH = 20;
  const displayItemCategoryName =
    itemCategoryName.length > MAX_LENGTH
      ? itemCategoryName.substring(0, MAX_LENGTH)
      : itemCategoryName;
  addText(
    doc,
    displayItemCategoryName,
    column1X,
    (myY += margin * 1.5),
    55,
    'left',
  );

  myY = 17;
  await addQrCode(doc, qrData, column2X, myY, qrWidth, qrHeight);

  myY += qrHeight + 1;

  setFont(doc);
  doc.setFontSize(8);
  addText(
    doc,
    `PAQUETE: ${itemNumber}/${itemTotal}`,
    column2X + 2,
    myY,
    45,
    'left',
  );

  myY += margin * 1.3;
  addText(doc, `PESO: ${weight} kg`, column2X + 2, myY, 45, 'left');

  myY += margin * 1.3;
  if (price) {
    addText(doc, `MONTO: S/ ${price}`, column2X + 2, myY, 45, 'left');
  }
};

function arrayBufferToBase64(buffer) {
  let binary = '';
  const bytes = new Uint8Array(buffer);
  const len = bytes.byteLength;
  // eslint-disable-next-line no-plusplus
  for (let i = 0; i < len; i++) {
    binary += String.fromCharCode(bytes[i]);
  }
  return window.btoa(binary);
}

export default async function printBaggageSticker(baggage) {
  const doc = createPdfDocument('l', 'mm', [112, 65]);

  const {
    sourceLocation,
    destinationLocation,
    mainTicket,
    itemList,
    tagNumber,
    excessBaggage,
  } = baggage;

  const excessPrice = excessBaggage ? excessBaggage.price : null;
  const lastItemIndex = itemList.length - 1;

  const printTasks = itemList.map((item, index) => async () => {
    await printBaggageItemSticker(doc, {
      sourceLocationName: sourceLocation.name,
      sourceAgencyCode: sourceLocation.agencyCode,
      destinationLocationName: destinationLocation.name,
      destinationAgencyCode: destinationLocation.agencyCode,
      passengerName: mainTicket.customer.fullName,
      ticketCode: mainTicket.ticketCode,
      description: item.description,
      itemCorrelation: item.itemCorrelation,
      itemNumber: index + 1,
      itemTotal: itemList.length,
      weight: item.weight,
      price: index === lastItemIndex ? excessPrice : null,
      qrData: String(item.id),
      isFirstPrint: index === 0,
      ticketCount: baggage.ticketList.length,
      tagNumber: tagNumber ? String(tagNumber).padStart(7, '0') : '-',
      isSpecial: item.isSpecial || false,
      itemCategoryName: item.itemCategoryName || '',
      departureDate: tzNormalizeDate({
        date: mainTicket.departureDate,
        format: TIME_FORMAT,
      }),
    });
  });

  await printTasks.reduce(
    (chain, task) => chain.then(() => task()),
    Promise.resolve(),
  );

  doc.autoPrint();
  const arrayBuffer = doc.output('arraybuffer');

  const blob = new Blob([arrayBuffer], { type: 'application/pdf' });
  const blobUrl = URL.createObjectURL(blob);
  const pdfBase64 = arrayBufferToBase64(arrayBuffer);

  try {
    await fetch(`${BASE_PRINT_AGENT_URL}/health`);
  } catch {
    window.open(blobUrl, '_blank');
    toastr.error(
      'Error',
      'El agente de impresión no está corriendo. Abre print-agent.exe primero.',
    );
    return;
  }

  try {
    const response = await fetch(`${BASE_PRINT_AGENT_URL}/print`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ pdfBase64, printingType: 'sticker' }),
    });

    if (!response.ok) {
      const errData = await response.json();
      throw new Error(errData.error || 'Error al imprimir');
    }
  } catch (err) {
    window.open(blobUrl, '_blank');
    toastr.error('Error', err.message);
  }
}
